import { VariantProps, cva } from 'class-variance-authority'
import { PropsWithChildren } from 'react'
import { cn } from '../../utils/cn'

const LayoutVariants = cva('py-16 px-6 md:px-8 mx-auto w-full', {
  variants: {
    variant: {
      primary: 'lg:px-0 lg:max-w-[952px] xl:max-w-[1240px]',
      secondary: 'lg:px-0 lg:max-w-[624px] xl:max-w-[816px]',
    },
  },
  defaultVariants: {
    variant: 'primary',
  },
})

type Props = VariantProps<typeof LayoutVariants> &
  PropsWithChildren<{
    className?: string
  }>

const LayoutWithSpacing = ({ children, className, variant }: Props) => {
  return (
    <div className={cn(LayoutVariants({ variant, className }))}>{children}</div>
  )
}

export default LayoutWithSpacing
